export enum AdministrationType {
  AS_START_TIME = 'P',
  PER_DOCTOR_ORDER = 'C',
  FOR_NECESSARY_REASONS = 'N'
}

export enum DurationType {
  PROGRAMMED = 'P',
  UNLIMITED = 'C'
}